export enum ConfigKey {
  // The node environment (development | test | production)
  NODE_ENV = 'NODE_ENV',
  // Debug mode
  DEBUG = 'DEBUG',

  REACT_APP_SERVER_HOST = 'REACT_APP_SERVER_HOST',
  REACT_APP_USE_MOCKS = 'REACT_APP_USE_MOCKS',
}
